let __appBehaviorInstance;
class AppBehavior {
    constructor() {
        this.appSettings = null;
        if (!__appBehaviorInstance) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            __appBehaviorInstance = this;
        }
        return this;
    }
    setAppPreferences(appSettings) {
        // Application settings will be injected by the application itself via webview interface
        // when initialize the application...
        this.appSettings = appSettings;
    }
    allowODECreationFeature() {
        // Return the app settings preference if exists
        if (this.appSettings && this.appSettings.allowODECreationFeature)
            return this.appSettings.allowODECreationFeature;
        // Otherwise, check the default Swym app preferences
        return false;
    }
    allowODEViewerFeature() {
        // Return the app settings preference if exists
        if (this.appSettings && this.appSettings.allowODEViewerFeature)
            return this.appSettings.allowODEViewerFeature;
        // Otherwise, check the default Swym app preferences
        return false;
    }
    allowODECollabFeature() {
        // Return the app settings preference if exists
        if (this.appSettings && this.appSettings.allowODECollabFeature)
            return this.appSettings.allowODECollabFeature;
        // Otherwise, check the default Swym app preferences
        return false;
    }
    activateNativeWindowBar() {
        // Return the app settings preference if exists
        if (this.appSettings && this.appSettings.activateNativeWindowBar)
            return this.appSettings.activateNativeWindowBar;
        // Otherwise, check the default Swym app preferences
        return false;
    }
    hasMultiWindowsSupport() {
        // Return the app settings preference if exists
        if (this.appSettings && this.appSettings.hasMultiWindowsSupport)
            return this.appSettings.hasMultiWindowsSupport;
        // Otherwise, check the default Swym app preferences
        return false;
    }
    disableTopbarLogout() {
        // Return the app settings preference if exists
        if (this.appSettings && this.appSettings.disableTopbarLogout)
            return this.appSettings.disableTopbarLogout;
        // Otherwise, check the default Swym app preferences
        return false;
    }
}
export const AppFeaturePreference = new AppBehavior();
//# sourceMappingURL=common-behaviors.js.map